// extracted by mini-css-extract-plugin
export default {"extensionContainer":"Eo7DNZlPzj"};